import { FormBlock } from '@eastcoal/formily/components/FormBlock'
import { SchemaItem } from '@eastcoal/formily/components/SchemaForm/interface'

import { AuditResultAlert } from '../../components/AuditResultAlert.tsx'

import { businessLicenseSchema } from './businessLicenseSchema'
import { kindSchema } from './kindSchema'
import { otherSchema } from './otherSchema'

export const auditEnterpriseFormSchema: SchemaItem[] = [
  {
    type: 'void',
    'x-component': AuditResultAlert
  },
  {
    type: 'void',
    'x-component': FormBlock,
    properties: {
      kindPanel: {
        type: 'void',
        title: '交易意向品类',
        'x-component': FormBlock.Panel,
        properties: kindSchema
      },
      businessLicensePanel: {
        type: 'void',
        title: '企业信息',
        'x-component': FormBlock.Panel,
        properties: businessLicenseSchema
      },
      otherInfoPanel: {
        type: 'void',
        title: '其他信息',
        'x-component': FormBlock.Panel,
        properties: otherSchema
      }
    }
  }
]
